import K_Toolbar from "../templates/K_Toolbar";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface ToolbarOptions extends ComponentOptions {
    components?: Component[];
    leftComponents?: Component[];
    rightComponents?: Component[];
}

export class Toolbar extends TemplateComponent {

    options: ToolbarOptions;
    content: {
        components: Component[];
        leftComponents: Component[];
        rightComponents: Component[];
    };
    resizeWindowHandler: () => void;

    constructor(options: ToolbarOptions) {
        super(K_Toolbar, options);

        this.content = {
            components: options.components || [],
            leftComponents: options.leftComponents || [],
            rightComponents: options.rightComponents || []
        };
    }

    create() {
        var me = this;

        me.resizeWindowHandler = function () {
            me.resizeWindow();
        };

        $(window).bind("resize", me.resizeWindowHandler);
        this.resizeWindow();
    }

    resizeWindow() {
        var me = this;

        var windowElem = $(window);

        $("#" + me.id).css({
            width: windowElem.width() > 996 ? windowElem.width() : 996
        });
    }

    destroy() {
        $(window).unbind("resize", this.resizeWindowHandler);
    }

}
